import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "buttonText"]
  static values = {
    ticketId: String
  }

  connect() {
    // Controlador conectado
  }

  toggle(event) {
    event.stopPropagation()
    console.log("🔘 Toggle resolution form")
    
    const isExpanded = !this.formTarget.classList.contains('hidden')
    
    if (isExpanded) {
      // Contraer
      this.formTarget.classList.add('hidden')
      this.buttonTextTarget.textContent = 'Resolver'
      console.log("📦 Formulario contraído")
      
      // Emitir evento de cancelación
      window.dispatchEvent(new CustomEvent('ticket-resolution-cancel', {
        detail: { ticketId: this.ticketIdValue }
      }))
    } else {
      // Expandir
      this.formTarget.classList.remove('hidden')
      this.buttonTextTarget.textContent = 'Cancelar'
      
      // Inicializar el formulario interno lazy (canvas, etc.)
      setTimeout(() => {
        const formElement = this.formTarget.querySelector('[data-controller*="ticket-resolution-form"]')
        if (formElement) {
          // Obtener el controller de Stimulus y llamar initializeLazy
          const app = this.application
          const controller = app.getControllerForElementAndIdentifier(formElement, 'ticket-resolution-form')
          if (controller && typeof controller.initializeLazy === 'function') {
            controller.initializeLazy()
          }
        }
        this.formTarget.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      }, 50)
    }
  }

  close() {
    this.formTarget.classList.add('hidden')
    this.buttonTextTarget.textContent = 'Resolver'
    
    // Emitir evento de cancelación (para volver al mapa si se vino desde allí)
    window.dispatchEvent(new CustomEvent('ticket-resolution-cancel', {
      detail: { ticketId: this.ticketIdValue }
    }))
  }
}
